import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgVkIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M.096 16.69c0-7.542 0-11.313 2.343-13.656S8.554.69 16.096.69c7.543 0 11.314 0 13.657 2.343s2.343 6.114 2.343 13.657c0 7.542 0 11.313-2.343 13.657-2.343 2.343-6.114 2.343-13.657 2.343-7.542 0-11.314 0-13.657-2.344C.096 28.005.096 24.233.096 16.691Z"
      fill="#2F8AF2"
    />
    <path
      d="M26.472 11.515c.15-.496 0-.86-.706-.86h-2.338c-.595 0-.867.315-1.017.66 0 0-1.189 2.9-2.873 4.78-.544.547-.793.72-1.09.72-.148 0-.363-.173-.363-.669v-4.631c0-.595-.172-.86-.667-.86h-3.675c-.371 0-.595.275-.595.538 0 .563.842.693.928 2.28v3.442c0 .754-.135.892-.434.892-.792 0-2.72-2.91-3.864-6.242-.223-.647-.448-.909-1.045-.909H6.395c-.668 0-.802.315-.802.66 0 .621.793 3.692 3.691 7.754 1.932 2.774 4.653 4.278 7.131 4.278 1.486 0 1.67-.334 1.67-.91v-2.097c0-.667.14-.802.611-.802.346 0 .94.175 2.328 1.512 1.585 1.584 1.847 2.296 2.738 2.296h2.337c.668 0 1.002-.334.81-.993-.21-.656-.968-1.61-1.972-2.74-.546-.644-1.362-1.337-1.61-1.684-.347-.447-.247-.644 0-1.04 0 0 2.849-4.011 3.145-5.375Z"
      fill="#fff"
    />
  </svg>
);
const Memo = memo(SvgVkIcon);
export default Memo;
